export default __webpack_public_path__ + "static/media/patillas.73570b70.png";